import type { AppRole } from "@/contexts/AuthContext";

interface PostLoginTargetArgs {
  role: AppRole;
  fromPath?: string;
  pendingOnboardingRoute?: string | null;
}

export function getDefaultRouteForRole(role: AppRole): string {
  const routes: Record<AppRole, string> = {
    user: "/dashboard",
    admin: "/admin",
    analyst: "/admin",
    adigig: "/adigig",
    super_admin: "/admin",
  };

  return routes[role];
}

export function getPostLoginTarget({ role, fromPath, pendingOnboardingRoute }: PostLoginTargetArgs): string {
  if (pendingOnboardingRoute && role === "user") {
    const normalizedFrom = fromPath || "";
    const isDefaultUserDestination = !normalizedFrom || normalizedFrom === "/" || normalizedFrom === "/dashboard";

    if (isDefaultUserDestination || normalizedFrom.startsWith("/onboarding")) {
      return pendingOnboardingRoute;
    }
  }

  const fallbackRoute = getDefaultRouteForRole(role);

  if (!fromPath) {
    return fallbackRoute;
  }

  if (fromPath.startsWith("/admin") && role !== "admin" && role !== "analyst" && role !== "super_admin") {
    return fallbackRoute;
  }

  if (fromPath.startsWith("/adigig") && role !== "adigig") {
    return fallbackRoute;
  }

  return fromPath;
}